module.exports = __webpack_public_path__ + "img/small-separated.420a2cc.svg";